import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-portal-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-template #content>
      <img *ngIf="hasLogo" [src]="logo" [alt]="name" (error)="onLogoError()" [class]="logoClass" />

      <span *ngIf="!hasLogo" class="text-aav-label-medium-strong text-aav-on-surface">{{
        name
      }}</span>

      <span
        *ngIf="count !== null"
        class="inline-flex shrink-0 items-center gap-[5px] text-[15px] font-bold text-aav-on-surface"
      >
        <span aria-hidden="true">{{ count }}</span>
        <aav-icon name="directions_car" [size]="16" class="text-aav-on-surface-variant"></aav-icon>
        <span class="sr-only">{{ count }} veículos publicados</span>
      </span>
    </ng-template>

    <button
      *ngIf="clickable; else plain"
      type="button"
      [title]="name"
      [attr.aria-label]="name"
      (click)="clicked.emit()"
      class="flex h-10 w-[120px] cursor-pointer items-center justify-center rounded-aav-sm border-[1px] border-solid border-aav-outline-variant bg-aav-surface px-[10px] py-[6px] transition-colors hover:border-aav-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-aav-primary"
    >
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </button>

    <ng-template #plain>
      <span class="flex min-w-0 items-center justify-between gap-[10px] px-[16px] py-[12px]">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </span>
    </ng-template>
  `,
})
export class PortalCardComponent implements OnChanges {
  @Input() name = '';
  @Input() logo: string | null = null;
  @Input() count: number | null = null;
  @Input({ transform: booleanAttribute }) clickable = false;

  @Output() clicked = new EventEmitter<void>();

  private logoFailed = false;

  get hasLogo(): boolean {
    return !!this.logo && !this.logoFailed;
  }

  get logoClass(): string {
    return this.clickable
      ? 'block max-h-[22px] w-auto max-w-full object-contain'
      : 'h-7 w-auto max-w-[110px] shrink-0 object-contain';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['logo']) {
      this.logoFailed = false;
    }
  }

  onLogoError(): void {
    this.logoFailed = true;
  }
}
